import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box
} from '@mui/material';
import { History } from '@mui/icons-material';

const RecentFlightLogsCard = ({ recentFlightLogs }) => {
  if (recentFlightLogs.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <History color="info" />
        Recent Flight Log Entries
      </Typography>
      <List>
        {recentFlightLogs.map((log) => (
          <ListItem key={log._id} divider>
            <ListItemText
              primary={
                log.sector?.trip 
                  ? `${log.sector.trip.charterNumber || 'N/A'} - Sector ${log.sector.seqNo || 'N/A'}`
                  : `Sector ${log.sector?.seqNo || 'N/A'}`
              }
              secondary={
                <Box>
                  <Typography variant="body2" component="span">
                    {log.entryType === 'POST_FLIGHT' && log.flightTime 
                      ? `Flight Time: ${log.flightTime} hrs • ` 
                      : ''}
                    {log.sector?.departure?.airport || 'N/A'} → {log.sector?.arrival?.airport || 'N/A'}
                    {log.createdBy ? ` • By: ${log.createdBy.firstName || ''} ${log.createdBy.lastName || ''}` : ''}
                    {log.createdAt ? ` • ${new Date(log.createdAt).toLocaleString()}` : ''}
                  </Typography>
                  {log.incidents && (
                    <Typography variant="caption" color="error" display="block" sx={{ mt: 0.5 }}>
                      ⚠️ Incidents reported
                    </Typography>
                  )}
                </Box>
              }
            />
            <Chip
              label={log.entryType === 'POST_FLIGHT' ? 'Post-Flight' : 'Pre-Flight'}
              size="small"
              color={log.entryType === 'POST_FLIGHT' ? 'primary' : 'default'}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default RecentFlightLogsCard;

